var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMicOffRedSlashIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9938 11.3093L19.9993 8C19.9993 5.78667 18.2127 4 15.9993 4C13.786 4 11.9993 5.78667 11.9993 8V16C11.9993 16.9288 12.314 17.7824 12.8427 18.4605L19.9938 11.3093ZM10.742 20.5612C9.63268 19.389 8.93268 17.8185 8.93268 16H6.66602C6.66602 18.3629 7.63985 20.5075 9.18677 22.1164L10.742 20.5612ZM10.7214 23.4102L12.3226 21.809C13.4182 22.4457 14.6902 22.8 15.9993 22.8C19.6793 22.8 23.066 20 23.066 16H25.3327C25.3327 20.56 21.706 24.32 17.3327 24.96V29.3333H14.666V24.96C13.2381 24.7467 11.8899 24.2036 10.7214 23.4102ZM14.4439 19.6877L19.9891 14.1425L19.986 16C19.986 18.2133 18.2127 20 15.9993 20C15.4473 20 14.9218 19.8889 14.4439 19.6877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3731 2.9272L2.91722 28.383L0.795898 26.2617L26.2517 0.805875L28.3731 2.9272Z",
    fill: "#FF5563"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -1.2041,
    y: 0.806641,
    width: 31.5772,
    height: 31.5772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicOffRedSlashIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mic-off-red-slash-icon.cfc45054.svg";
export { ForwardRef as ReactComponent };